<template>
  <div class="nd-wrap">
    <div class="news-title">{{ detail.noticeTitle }}</div>
    <div class="news-time">发布时间：{{ detail.releaseTime }}</div>
    <div
      v-if="detail.noticeType != '3'"
      v-html="detail.noticeContent"
      class="text"
    ></div>
    <div v-else>
      <el-carousel :height="bannerHeight + 'px'">
        <el-carousel-item
          v-for="(item, index) in detail.bannerList"
          :key="index"
        >
          <div
            style="
              position: relative;
              height: 100%;
              display: flex;
              justify-content: center;
            "
          >
            <img
              :src="item"
              alt="img"
              ref="bannerHeight"
              style="height: 100%"
            />
          </div>
        </el-carousel-item>
      </el-carousel>
      <div style="text-align: center; margin: 10px">
        {{ detail.noticeTitle }}
      </div>
    </div>

    <div class="action-wrap">
      <div class="prev">
        <div class="img-wrap">
          <img src="../assets/news/prev.png" alt="img" class="img" />
        </div>
        <div class="btn" @click="handleChangePage('prev')">上一篇</div>
      </div>
      <div class="back" @click="handleBack">返回列表</div>
      <div class="next">
        <div class="btn" @click="handleChangePage('next')">下一篇</div>
        <div class="img-wrap">
          <img src="../assets/news/next.png" alt="img" class="img" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "newsDetail",
  data() {
    return {
      baseUrl: process.env.VUE_APP_BASE_API,
      detail: {
        noticeTitle: "",
        createTime: "",
        noticeContent: "",
        bannerList: [],
      },
      bannerHeight: "",
      activeBannerHeight: 0,
    };
  },
  mounted() {
    scrollTo({ top: 0 });
    this.getInfo(this.$route.query.id);
    this.setSize();
    window.addEventListener(
      "resize",
      () => {
        this.setSize();
      },
      false
    );
  },
  methods: {
    setSize() {
      this.bannerHeight = document.body.clientWidth / 3.84; //这个比例是1920/500
    },
    handleChangePage(action) {
      let type = null;
      if (action === "prev") {
        type = "1";
      }
      if (action === "next") {
        type = "0";
      }
      fetch(
        `/prod-api/system/notice/nextList?noticeId=${this.detail.noticeId}&type=${type}&pageNum=1&pageSize=1&noticeType=${this.$route.query.noticeType}`,
        {
          method: "get",
        }
      )
        .then((res) => {
          return res.json();
        })
        .then((res) => {
          if (res.rows.length === 0) {
            if (action === "prev") {
              this.$message.warning("前面没有了");
            }
            if (action === "next") {
              this.$message.warning("后面没有了");
            }
            return;
          }
          this.detail = res.rows[0];
          this.detail.bannerList = res.rows[0].fileUrls
            .split(",")
            .map((i) => this.baseUrl + i);

          this.$router.push({
            path: "/newsDetail",
            query: {
              id: res.rows[0].noticeId,
              noticeType: res.rows[0].noticeType,
            },
          });
        });
      window.scrollTo({ top: 0 });
    },
    getInfo(id) {
      fetch(`/prod-api/system/notice/detail/${id}`, {
        method: "get",
      })
        .then((res) => {
          return res.json();
        })
        .then((res) => {
          this.detail = res.data;
          this.detail.bannerList = res.data.fileUrls
            .split(",")
            .map((i) => this.baseUrl + i);
        });
    },
    handleBack() {
      this.$router.push("/news");
      window.scrollTo({ top: 0 });
    },
  },
};
</script>
<style scoped lang="less">
.nd-wrap {
  min-height: 820px;
  width: 990px;
  margin: 0 auto;
  .news-title {
    text-align: center;
    margin-top: 60px;
    margin-bottom: 30px;
    font-weight: 400;
    font-size: 30px;
    color: #454545;
  }
  .news-time {
    text-align: center;
    font-weight: 400;
    font-size: 14px;
    color: #454545;
    margin-bottom: 44px;
  }
}
.action-wrap {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 50px;
  .back {
    color: #5bb0ff;
    font-weight: 400;
    font-size: 18px;
    cursor: pointer;
  }
  .prev,
  .next {
    width: 150px;
    height: 50px;
    border: 1px solid #e5e5e5;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    .img-wrap {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 50px;
      height: 50px;
      .img {
        width: 16px;
        height: 14px;
      }
    }

    .btn {
      height: 50px;
      width: 100px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  .prev .btn {
    border-left: 1px solid #e5e5e5;
  }
  .next .btn {
    border-right: 1px solid #e5e5e5;
  }
}
.text {
  ::v-deep img {
    width: 100%;
    max-width: 100%;
  }
}
</style>
